export default __webpack_public_path__ + "static/media/8818-niftynaut.87f859bf.pdf";